import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { Styled, StyledButton, StyledMessageContainer } from "./styles";

interface Props {
  remainingTrialDays: number | null;
  onClickSubscribe: () => void;
  isFullWidth?: boolean;
}

export const PixiSubscribeBanner = (props: Props): JSX.Element => {
  const { remainingTrialDays, onClickSubscribe, isFullWidth } = props;

  return (
    <Styled
      isFullWidth={isFullWidth || false}
      data-testid="pixi-subscribe-banner"
      className="pixi-subscribe-banner"
      id="pixi-subscribe-banner"
    >
      <StyledMessageContainer data-testid="pixi-subscribe-message">
        <FormattedHTMLMessage
          id="ads.banner.pixi_subscribe_message"
          defaultMessage="<strong>{dayLeft} days left!</strong> Pay monthly or get a free device with an annual subscription."
          values={{ dayLeft: remainingTrialDays }}
        />
      </StyledMessageContainer>
      <StyledButton
        mini
        onClick={onClickSubscribe}
        data-testid="pixi-subscribe-button"
      >
        <FormattedMessage
          id="ads.banner.subscribe_now"
          defaultMessage="Subscribe Now"
        />
      </StyledButton>
    </Styled>
  );
};
